import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

const legacyPage = location.pathname === '/' ? location.hash.replace(/^#\/?/, '') : '';
if (legacyPage) history.replaceState(null, '', `/${legacyPage}`);

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
